import { render } from "./HelpDeskPage.vue?vue&type=template&id=5e472e7d&ts=true"
import script from "./HelpDeskPage.vue?vue&type=script&lang=ts"
export * from "./HelpDeskPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__